export const GroupCommitteesTableData = {
    rows: [
        { title: 'Group Risk & Capital Management Committee (GRCMC)', id: 1 },
        { title: 'Group Risk Oversight Committee (GROC)', id: 2 },
        { title: 'Group Risk Data Committee (GRDC)', id: 3 },
    ],
    total: 3,
};

export const GroupCommitteesTableColumns = [
    {
        displayName: 'Group RDARR Committees',
        sortColumnName: 'title',
        dataType: 'string',
        dataKey: 'title',
        settings: { sort: true, filter: false, multiple: false },
        css: 'pad-end',
    },
];

export const GroupCommitteesSortingConfig = {
    sortByColumn: 'title',
    sortByDescending: false,
    callback: () => {},
};

export const GroupCommitteesPaginationConfig = {
    paginationEvent: () => {},
    paginationData: {
        pageNumber: 1,
        pageSize: 5,
        total: GroupCommitteesTableData.total,
    },
    defaultPageSize: {
        value: 5,
        text: '5',
    },
};
